<script setup lang="ts">
import { onMounted } from 'vue';
import OrderConfirmation from '@/components/ui/OrderConfirmation.vue';
import BaseErrorState from '@/components/ui/BaseErrorState.vue';
import { $t } from '@/composables/translations/useTranslate';
import { useThankYouSharing } from '@/composables/checkout/useThankYouSharing';

const { params, shareUrl, initialize } = useThankYouSharing();

function handleGoHome() {
  window.location.href = '/';
}

onMounted(async () => {
  await initialize();
});
</script>

<template>
  <div class="wrapper">
    <OrderConfirmation
      v-if="params.bookingNumber"
      :booking-number="params.bookingNumber"
      :share-url="shareUrl"
    />

    <BaseErrorState
      v-else
      icon="icon-warning"
      icon-class="bg-error"
      :title="$t('ibe.thankyou.error.title', 'Booking number missing')"
      :message="$t('ibe.thankyou.error.message', 'No booking number was provided.')"
      :primary-button="{
        text: $t('ibe.thankyou.error.button', 'Go to homepage'),
        onClick: handleGoHome,
      }"
      size="compact"
    />
  </div>
</template>
